<template>
  <div>
    <h2>FormMedicalFollowup</h2>
  </div>
</template>

<script>
  export default {
    name: "FormMedicalFollowup",
  }
</script>

<style lang="css" scoped>

</style>